import { render, staticRenderFns } from "./PartyQuickReport.vue?vue&type=template&id=b6b532b8"
import script from "./PartyQuickReport.vue?vue&type=script&lang=js"
export * from "./PartyQuickReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports